import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ParametersService} from '../../../../core/boarding/_services/parameters.service';
import {AuditService} from '../../../../core/_base/services/audit.service';
import { ConfigService } from 'src/app/core/_base/services/config.service';

@Component({
  selector: 'app-statements',
  templateUrl: './statements.component.html',
  styleUrls: ['./statements.component.scss']
})
export class StatementsComponent implements OnInit {
  LeyendaAutorizacion:string = '';
  textoPrincipal = '';
  constructor(private dialogRef: MatDialogRef<StatementsComponent>,
    public auditService: AuditService,
    private configS: ConfigService,
    public parametersService: ParametersService,
    @Inject(MAT_DIALOG_DATA) public data?: any) { }


  async ngOnInit() {
    this.textoPrincipal = this.configS.getValue('PRINCIPAL_TIT_AUTORIZACION');
    if(this.data.leyendaAutorizacion == null || this.data.leyendaAutorizacion == undefined){
      console.log('orizacion == null || t');
      this.LeyendaAutorizacion = String((await this.parametersService.GetInitialParameters(this.auditService?.getAudit())?.toPromise())?.LeyendaAutorizacion);
    }else{
      this.LeyendaAutorizacion = this.data.leyendaAutorizacion;
    }
  }

  close(): void {
    this.dialogRef.close({leyenda:this.LeyendaAutorizacion});
  }

}
